import React, {useEffect} from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {useHeader} from "../../../contexts/HeaderContext";
import EtatChocPage from "./EtatChocPage";

const EtatChocWrapper = () => {
  const {setTitle} = useHeader();

  useEffect(() => {
    setTitle("Gestion des Etats / Chocs");
  }, [setTitle]);

  return (
    <Routes>
      <Route path='' element={<EtatChocPage/>}/>

      <Route path='*' element={<Navigate to='/404' replace/>}/>
    </Routes>
  )
}

export {EtatChocWrapper}